<div class="campaign-container">
  <div class="campaign-card">
    <!-- Header -->
    <div class="card-header">
      <div class="header-left">
        <div class="header-icon">
          <i class="fa-solid fa-bullhorn"></i>
        </div>
        <div class="header-text">
          <h2 class="card-title">Create New Campaign</h2>
          <p class="card-subtitle">Reach your audience with targeted SMS campaigns</p>
        </div>
      </div>

      <!-- Campaign Type Switcher -->
      <div class="type-switcher">
        <button
          type="button"
          class="type-btn"
          [class.active]="campaignType() === 'unicast'"
          (click)="setCampaignType('unicast')"
        >
          Unicast
        </button>
        <button
          type="button"
          class="type-btn"
          [class.active]="campaignType() === 'multicast'"
          (click)="setCampaignType('multicast')"
        >
          Multicast
        </button>
        <button
          type="button"
          class="type-btn"
          [class.active]="campaignType() === 'excel'"
          (click)="setCampaignType('excel')"
        >
          Excel Plugin
        </button>
      </div>
    </div>

    <form [formGroup]="campaignForm" (ngSubmit)="onSubmit()" class="campaign-form">
      <div class="form-grid">
        <!-- Campaign Name -->
        <div class="form-group full-width">
          <label for="name">Campaign Name</label>
          <div class="input-wrapper">
            <div class="input-icon">
              <i class="fa-solid fa-tag"></i>
            </div>
            <input
              id="name"
              type="text"
              formControlName="name"
              placeholder="Enter campaign name (e.g. Summer Promo 2026)"
            />
          </div>
        </div>

        <!-- Package Selection -->
        <div class="selection-section full-width">
          <label for="packagePlan">Select Package Plan</label>
          <div class="cards-grid">
            @for (pkg of packages(); track pkg.name) {
              <button
                type="button"
                class="selection-card"
                [class.active]="campaignForm.get('package')?.value.name === pkg.name"
                (click)="selectPackage(pkg)"
              >
                <div class="card-check">
                  <i class="fa-solid fa-check"></i>
                </div>
                <div class="card-content">
                  <span class="pkg-name">{{ pkg.name }}</span>
                  <span class="pkg-sub">Active</span>
                </div>
              </button>
            }
          </div>
        </div>

        <!-- Sender ID Selection -->
        <div class="selection-section full-width">
          <label for="senderId">Select Sender ID</label>
          <div class="cards-grid">
            @for (id of senderIds(); track id) {
              <button
                type="button"
                class="selection-card sender-card"
                [class.active]="campaignForm.get('senderId')?.value === id"
                (click)="selectSenderId(id)"
              >
                <div class="card-check">
                  <i class="fa-solid fa-check"></i>
                </div>
                <div class="card-content">
                  <span class="sender-name">{{ id }}</span>
                  <span class="sender-sub">Verified</span>
                </div>
              </button>
            }
          </div>
        </div>

        <!-- Message Text (Unicast & Excel only) -->
        @if (campaignType() !== 'multicast') {
          <div class="form-group full-width">
            <label for="messageText">Message Content</label>
            <div class="textarea-container">
              <textarea
                id="messageText"
                formControlName="messageText"
                placeholder="Enter your campaign message here..."
                rows="4"
              ></textarea>
              <div class="textarea-stats">
                <span>Total Messages: {{ messageCount }}</span>
                <span>Total characters: {{ charCount }}</span>
              </div>
            </div>
          </div>
        }

        <!-- Schedule Date & Excel Upload Row -->
        <div class="form-row schedule-row full-width">
          <!-- Schedule Date & Time (50%) -->
          <div class="form-group schedule-group">
            <label for="scheduleDate">Schedule Date & Time</label>
            <app-date-time-picker formControlName="scheduleDate" placeholder="Select Date & Time" />
          </div>

          <!-- Sample Excel (25%) -->
          <div class="form-group action-group">
            <label for="">&nbsp;</label>
            <button type="button" class="btn-sample" (click)="downloadSample()">
              <i class="fa-solid fa-download"></i>
              Sample Excel
            </button>
          </div>

          <!-- Excel Upload (25%) -->
          <div class="form-group action-group">
            <label for="">&nbsp;</label>
            <div class="file-upload-wrapper">
              <input
                type="file"
                id="excelFile"
                (change)="onFileSelected($event)"
                accept=".xlsx, .xls"
                class="file-input"
              />
              <label for="excelFile" class="btn-upload">
                <i class="fa-solid fa-file-excel"></i>
                {{ selectedFile() ? selectedFile()?.name : 'Select Excel File' }}
              </label>
            </div>
          </div>
        </div>
      </div>

      <!-- Footer Action Bar -->
      <div class="form-footer-bar">
        <div class="total-info">
          @if (isValidated()) {
            <div class="validated-stats">
              <div class="stat-item">
                <span class="total-label">ESTIMATED COST</span>
                <span class="total-value">{{ campaignCost() | number: '1.2-2' }} ฿</span>
              </div>
            </div>
          }
        </div>

        <div class="action-buttons">
          @if (!isValidated()) {
            <button
              type="button"
              class="btn-validate"
              (click)="validateCampaign()"
              [disabled]="campaignForm.invalid || !selectedFile() || isValidating()"
            >
              @if (isValidating()) {
                <i class="fa-solid fa-circle-notch fa-spin"></i>
                Validating...
              } @else {
                <i class="fa-solid fa-magnifying-glass-chart"></i>
                Validate Campaign
              }
            </button>
          } @else {
            <button type="submit" class="btn-confirm" [disabled]="campaignForm.invalid">
              <i class="fa-solid fa-rocket"></i>
              Launch Campaign
            </button>
          }
        </div>
      </div>
    </form>
  </div>
</div>
